import React from 'react';
import Review from './review';
import '../css/Service.css';

function ChemicalWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={'/img_3.jpg'} alt="Chemical Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Chemical Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>CHEMICAL WASTE MANAGEMENT</h1>
        <p>We have programs to handle a wide variety of chemical waste streams with safe, compliant solutions.</p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Our programs include:</h2>
          <ul className="feature-list">
            <li>Lab pack solutions &amp; laboratory waste management: inventory, segregation, packaging and shipment of a variety of chemicals.</li>
            <li>Chemical waste recycling: reclaim, reuse or beneficial reuse of used solvents and other chemicals.</li>
            <li>Chemical waste disposal: disposal under EPA guidelines for each waste stream.</li>
            <li>Disposition of unused chemicals: we locate buyers for unused and unwanted chemicals when feasible.</li>
          </ul>

          <p>
            Our expert team can assist in identification, segregation, storage, removal, transportation and disposal of your organization's chemical waste. We tailor solutions to site needs and regulatory requirements.
          </p>

          <h3>Chemical waste streams include:</h3>
          <ol className="feature-list">
            <li>Unused and surplus reagent-grade chemicals</li>
            <li>Intermediates and by-products generated from research &amp; educational experiments</li>
            <li>Batteries</li>
            <li>Anything contaminated by chemicals</li>
            <li>Used oil of all types</li>
            <li>Spent solvents (including water-based)</li>
            <li>Pesticides</li>
            <li>Non-returnable gas cylinders</li>
            <li>Non-empty aerosol cans</li>
            <li>Chemically contaminated sharps</li>
            <li>Finely divided powders</li>
            <li>Contaminated syringes, needles, GC syringes, razor blades, pasteur pipettes, pipette tips</li>
            <li>Paints — oil and latex</li>
            <li>Preserved specimens</li>
          </ol>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Chemical Waste Assistance</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Capabilities</h3>
            <ul className="specialty-list">
              <li>EPA-compliant disposal and treatment</li>
              <li>Secure transport and manifesting</li>
              <li>On-site waste characterization</li>
              <li>Flexible scheduling and nationwide coverage</li>
            </ul>
          </div>
        </aside>

      </section>

      <Review />
    </div>
  );
}

export default ChemicalWaste;
